import React from 'react'
import { css } from 'aphrodite'
import styles from './styles'
import Breadcrumbs from './Breadcrumbs'

export default ({ item = {}, style = {} }) => {
  if (item.type === 'node')
    return (
      <div style={style} className={css(styles.breadcrumbPositioner)}>
        <Breadcrumbs nodePath={item.path} />
      </div>
    )

  return <span />
}



// WEBPACK FOOTER //
// ./src/components/Media/group.js